import { InformationCircleIcon } from "@heroicons/react/outline";
import { Button } from "components/form/Button";
import FileUploadForm from "components/form/FileUploadForm";
import StarRating from "components/form/StarRating";
import Link from "next/link";
import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tippy";
import { classNames } from "util/common";

const ReviewGeneralStep = ({
	setValue,
	watch,
	control,
	register,
	errors,
	isSubmitting,
	claims,
	setStep,
	nextStep,
	isValid,
	trigger,
}) => {
	const tooltipContent = (
		<div className="text-start">
			<p className="font-bold mb-2">לעזור לקהילה - מדד ג&apos;יין</p>
			<p className="mb-2">
				חדש: מדד ג&apos;יין - מערכת ביקורות מוצרי קנאביס רפואי - האמינה
				והמשוכללת ביותר!
			</p>
			<p>
				מדד ג&apos;יין מאפשר מלבד חוות דעת כללית, גם הזנת אפיון חושי ופיזי של
				המוצר.
			</p>
		</div>
	);
	return (
		<div className="flex flex-col gap-4">
			<div className="bg-jane-100 text-jane-700 p-3 rounded-md mb-2">
				<p className="flex items-center">
					<InformationCircleIcon className="w-5 h-5 ml-1 inline-block" />
					הביקורת תפורסם תחת השם: {claims?.jane_username || "משתמש אנונימי"}
				</p>
				<p className="text-sm mt-1 mr-6">
					אם ברצונך לשנות את שם המשתמש, ניתן לעשות זאת ב
					<Link href="/account/edit">
						<a className="text-jane-600 underline font-semibold">חשבון שלי</a>
					</Link>
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<label className="text-black/70 font-semibold">
					דירוג:
					<span
						className={classNames(
							"text-jane-400 mr-1 text-sm",
							errors?.rating && "text-red-400",
						)}
					>
						(סעיף חובה)
					</span>
				</label>
				<StarRating control={control} name="rating" />
			</div>

			<div className="flex flex-col gap-1">
				<label className="text-black/70 font-semibold">
					תיאור:
					<span
						className={classNames(
							"text-jane-400 mr-1 text-sm",
							errors?.content && "text-red-400",
						)}
					>
						(סעיף חובה)
					</span>
				</label>
				<textarea
					{...register("content", {
						required: true,
						minLength: { value: 20, message: "מינימום 20 תווים." },
					})}
					className="w-3/4 rounded-md border-gray-300 resize-none focus:border-gray-300 focus:ring-0"
					cols={2}
					rows={3}
				></textarea>
				{errors?.content && (
					<span className="text-red-400">{errors.content.message}</span>
				)}
			</div>
			<div className="flex flex-col gap-1">
				<span className="text-black/70 font-semibold">
					תמונות:{" "}
					<span className="text-jane-400 text-sm ">
						({watch("images").length}/5)
					</span>
				</span>
				<FileUploadForm setValue={setValue} watch={watch} />
			</div>
			<div className="flex flex-col gap-1"></div>

			<div className="flex justify-end gap-2">
				<Button className="" type="submit" disabled={isSubmitting && !isValid}>
					שליחת ביקורת רגילה
				</Button>
				<Button
					primary
					className="gap-2"
					onClick={() => (isValid ? setStep(nextStep) : trigger())}
				>
					<span>המשך למדד ג&apos;יין</span>
					<span className="hidden lg:inline">
						<Tooltip arrow html={tooltipContent}>
							<FaInfoCircle className="w-4 h-4 text-white" />
						</Tooltip>
					</span>
				</Button>
				<span className="lg:hidden">
					<Tooltip arrow html={tooltipContent}>
						<div className="bg-jane-600 rounded-md p-2">
							<FaInfoCircle className="w-4 h-4 text-white " />
						</div>
					</Tooltip>
				</span>
			</div>
		</div>
	);
};

export default ReviewGeneralStep;
